export default __webpack_public_path__ + "static/media/left.76c4d90d.svg";